import React, { Component } from "react";

class Pagination extends Component {
  handlePageSwitch = (page, pagesLength) => {
    const { updateCurrentPage, activeTab } = this.props;
    if (page > 0 && page <= pagesLength) {
      updateCurrentPage(activeTab, page);
    }
  };

  render() {
    const { currentPage, totalFiles, split } = this.props;
    const pages = Array.from({ length: Math.ceil(totalFiles / split) }, (_, i) => i + 1);

    return (
      <div className="d-flex justify-content-center align-items-center flex-wrap">
        <div className="d-flex flex-wrap py-2 mr-3">
          <a
            onClick={() => this.handlePageSwitch(currentPage - 1, pages.length)}
            className="btn btn-icon btn-sm btn-light-primary mr-2 my-1"
          >
            <i className="ki ki-bold-arrow-back icon-xs"></i>
          </a>
          {pages.map((page) => (
            <a
              style={{ cursor: 'pointer' }}
              onClick={() => this.handlePageSwitch(page, pages.length)}
              key={page}
              className={`btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1 ${page === currentPage ? 'active' : ''}`}
            >
              {page}
            </a>
          ))}
          <a
            onClick={() => this.handlePageSwitch(currentPage + 1, pages.length)}
            className="btn btn-icon btn-sm btn-light-primary mr-2 my-1"
          >
            <i className="ki ki-bold-arrow-next icon-xs"></i>
          </a>
        </div>
      </div>
    );
  }
}

export default Pagination;